import { Autocomplete, Box, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { mobileInput_style } from './style';

export function SimpleSelect(props) {
  const {
    placeholder = '',
    id = '',
    value,
    options = [],
    disabled = false,
    handleChangeSelect = () => false,
    className = '',
    ...rest
  } = props;
  const getValue = (value, options) => {
    if (value && options?.length > 0) {
      return options.filter((val) => val.value === value)?.[0];
    }
    return value;
  };

  const giveMeValueLabel = (option) => `${option?.value}`;

  return (
    <Box sx={mobileInput_style.rootStyle} className={`${className}`} {...rest}>
      {/* label Of Mobile Input */}
      <Autocomplete
        id={id}
        sx={mobileInput_style.autocompleteSx}
        placeholder={placeholder}
        options={options}
        getOptionLabel={(option) => giveMeValueLabel(option)}
        disabled={disabled}
        onChange={(event, value) => handleChangeSelect(value?.value)}
        defaultValue={getValue(value, options)}
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            variant="outlined"
            placeholder={placeholder}
            autoComplete="true"
          />
        )}
      />
    </Box>
  );
}

SimpleSelect.propTypes = {
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  handleChangeSelect: PropTypes.func,
  className: PropTypes.string,
};
